var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    {
      staticClass: "padding-bottom-50",
      class: [
        _vm.isNewsAvailable ? "" : "padding-top-70",
        _vm.canShowMarketFilter ? "padding-bottom-s-0" : "padding-bottom-s-30",
      ],
      attrs: { "aria-labelledby": "xmoReleaseCalendar" },
    },
    [
      _vm.ajaxError
        ? _c("div", { staticClass: "alert alert-error animated" }, [
            _vm._v("\n        " + _vm._s(_vm.ajaxError) + "\n    "),
          ])
        : _c(
            "div",
            [
              _vm.canShowMarketFilter
                ? _c("ReleaseFilter", {
                    attrs: {
                      "is-mobile": _vm.isMobile,
                      "market-name": _vm.getMarketName,
                      locale: _vm.locale,
                    },
                    on: {
                      "filter-releases": function ($event) {
                        return _vm.setFilter($event)
                      },
                    },
                  })
                : [_vm._m(0)],
              _vm._v(" "),
              !_vm.isMobile
                ? _c(
                    "div",
                    {
                      staticClass:
                        "margin-horizontal-80 margin-horizontal-s-0 margin-top-50",
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "flex pos-relative" },
                        [
                          _vm.upcomingReleasesListLength > 3
                            ? _c("div", { staticClass: "releaseSlider" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "glide__arrow glide__arrow--left glide__release--left center",
                                    class: _vm.showPreviousButton
                                      ? ""
                                      : "opacity-30 pointerEvent--none",
                                    attrs: {
                                      type: "button",
                                      "aria-label": _vm.trans(
                                        "GLOBAL_PREVIOUS_MONTH"
                                      ),
                                      "aria-disabled": !_vm.showPreviousButton,
                                      "data-gtm":
                                        "upcomingReleasesButton--previous",
                                    },
                                    on: { click: _vm.previous },
                                  },
                                  [
                                    _c(
                                      "svg",
                                      { attrs: { "aria-hidden": "true" } },
                                      [
                                        _c("use", {
                                          attrs: {
                                            href: "#iconChevronLeftBold",
                                          },
                                        }),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "glide__arrow glide__arrow--right glide__release--right center",
                                    class: _vm.showNextButton
                                      ? ""
                                      : "opacity-30 pointerEvent--none",
                                    attrs: {
                                      type: "button",
                                      "aria-label":
                                        _vm.trans("GLOBAL_NEXT_MONTH"),
                                      "aria-disabled": !_vm.showNextButton,
                                      "data-gtm":
                                        "upcomingReleasesButton--next",
                                    },
                                    on: { click: _vm.next },
                                  },
                                  [
                                    _c(
                                      "svg",
                                      { attrs: { "aria-hidden": "true" } },
                                      [
                                        _c("use", {
                                          attrs: {
                                            href: "#iconChevronRightBold",
                                          },
                                        }),
                                      ]
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._l(
                            _vm.getDisplayedMonths(_vm.getUpcomingReleases()),
                            function (row, monthName, index) {
                              return [
                                _c(
                                  "div",
                                  {
                                    key: index,
                                    staticClass:
                                      "flex__item flex--directionColumn padding-horizontal-10 flex--grow1 width33 padding-horizontal-s-0",
                                  },
                                  [
                                    _c("release-list-title", {
                                      attrs: {
                                        "month-name": monthName,
                                        "upcoming-releases":
                                          _vm.getUpcomingReleases(),
                                        "show-monthly": _vm.showMonthly,
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "padding-right-10 scrollBox max-height-300",
                                      },
                                      [
                                        _c("release-list", {
                                          attrs: {
                                            "release-list-data":
                                              _vm.getReleasesData,
                                            "filtered-categories":
                                              _vm.filteredCategories,
                                            "time-frame": row,
                                            initialized: _vm.initialized,
                                            "no-data-info": _vm.trans(
                                              "SMI_RELEASE_NO_UPDATES"
                                            ),
                                            "panel-delay": index * 200,
                                            "filter-by-content-type":
                                              _vm.filterByContentType,
                                          },
                                          on: {
                                            "open-release-modal":
                                              _vm.openReleaseModal,
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            }
                          ),
                        ],
                        2
                      ),
                    ]
                  )
                : _c(
                    "div",
                    {
                      staticClass: "scrollBox max-height-300 padding-right-10",
                    },
                    [
                      _vm._l(
                        _vm.getDisplayedMonths(_vm.getUpcomingReleases()),
                        function (row, monthName, index) {
                          return [
                            _c(
                              "div",
                              { key: index },
                              [
                                _c("release-list-title", {
                                  attrs: {
                                    "month-name": monthName,
                                    "upcoming-releases":
                                      _vm.getUpcomingReleases(),
                                    "show-monthly": _vm.showMonthly,
                                  },
                                }),
                                _vm._v(" "),
                                _c("release-list", {
                                  attrs: {
                                    "release-list-data": _vm.getReleasesData,
                                    "filtered-categories":
                                      _vm.filteredCategories,
                                    "time-frame": row,
                                    initialized: _vm.initialized,
                                    "no-data-info": _vm.trans(
                                      "SMI_RELEASE_NO_UPDATES"
                                    ),
                                    "panel-delay": index * 200,
                                    "filter-by-content-type":
                                      _vm.filterByContentType,
                                  },
                                  on: {
                                    "open-release-modal": _vm.openReleaseModal,
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        }
                      ),
                    ],
                    2
                  ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "text-center float-none width100 margin-top-10 margin-bottom-30",
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "button button--medium button--primary",
                      class: { "button--fullwidth": _vm.isMobile },
                      attrs: {
                        "data-gtm": "xmoHubpage__upcomingReleases",
                        href: _vm.releasesPath,
                      },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.trans("OUTLOOK_UPCOMING_RELEASES")) +
                          "\n            "
                      ),
                    ]
                  ),
                ]
              ),
            ],
            2
          ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            "modal-open": _vm.releaseModalOpen,
            "custom-container-classes": [
              "vueModal__container--releaseCalendar",
            ],
          },
          on: {
            "toggle-modal": function ($event) {
              _vm.releaseModalOpen = false
            },
          },
        },
        [
          _vm.renderModalContent
            ? _c("div", { staticClass: "text-color--dark-blue-gray" }, [
                _vm.releaseModalContent.releaseDate
                  ? _c("div", [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.getLocalizedDate(
                              _vm.releaseModalContent.releaseDate.date
                            )
                          ) +
                          "\n            "
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("h3", { staticClass: "margin-bottom-10" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.releaseModalContent.title) +
                      "\n            "
                  ),
                ]),
                _vm._v(" "),
                _c("div", {
                  staticClass: "margin-bottom-5",
                  domProps: {
                    innerHTML: _vm._s(_vm.releaseModalContent.description),
                  },
                }),
                _vm._v(" "),
                _vm.releaseModalContent.link
                  ? _c(
                      "div",
                      { staticClass: "margin-top-10 margin-bottom-5" },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "linkArrowHover",
                            attrs: { href: _vm.releaseModalContent.link },
                          },
                          [
                            _c(
                              "svg",
                              {
                                staticClass: "stat__svgIcon",
                                attrs: { "aria-hidden": "true" },
                              },
                              [
                                _c("use", {
                                  attrs: { href: "#iconArrowRightLongBold" },
                                }),
                              ]
                            ),
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.trans("SMI_RELEASE_BUTTON_TEXT")) +
                                "\n                "
                            ),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "text-center text-s-left" }, [
      _c("h2", { staticClass: "sectionRooftitle" }, [
        _vm._v(
          "\n                    " +
            _vm._s(_vm.trans("RELEASE_CALENDAR")) +
            "\n                "
        ),
      ]),
      _vm._v(" "),
      _c("h3", { staticClass: "h2 margin-bottom-15 text-center" }, [
        _vm._v(
          "\n                    " +
            _vm._s(_vm.trans("INFOGRAPHIC_RELEASE_CALENDAR_PLANNED")) +
            "\n                "
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }